import React from "react";

import {
	IGameResultHistoryProps,
	IRedVsBlueDiceHistoryType
} from "@/types/GameHistoryTypes";

import { assetImg } from "@/modules/moduleImporter";

import "./index.scss";

interface IProps extends IGameResultHistoryProps {
	history: IRedVsBlueDiceHistoryType[];
}

export default class M39 extends React.Component<IProps> {
	private DiceRowFragment(props: { angka: string, idx: number, blink?: boolean }) {
		const { angka, idx, blink } = props;
		// console.log("DRF props: ", props);

		const [ red, blue ] = angka.match(/\d+/g);

		return (
			<div className={`dice-row ${blink ? 'sl-roadmap-alternating' : ''}`}>
				{assetImg("m39", `red_${red}`, `red_${idx}`)}
				{assetImg("m39", `blue_${blue}`, `blue_${idx}`)}
			</div>
		)
	}

	render() {
		const { DiceRowFragment } = this;

		const {history, historyBlink} = this.props;

		const reversedHistory = history.slice(0).reverse();

		return (
			<div className="history-container m39">
				{
					reversedHistory.slice(0, 6).map((item, idx) =>
						<DiceRowFragment
							blink={historyBlink && idx === 0}
							key={`m39-history-${idx}`}
							angka={item.angka}
							idx={idx} />
					)
				}
			</div>
		);
	}
}